import React from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';

import { translate, keys as keysSelector } from 'ggApp/modules/translator/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { replaceTranslatedStringValues } from 'ggApp/modules/translator/utils';

import './index.scss';

const enhance = connect(
    createStructuredSelector({
        translations: keysSelector,
        storeActive: activeStoreSelector,
    }),
);
export class ToolTip extends React.PureComponent {
    render() {
        const {
            theme,
            tooltipTK,
            position,
            trigger,
            interactive,
            hideOnClick,
            arrow,
            duration,
            translations,
            storeActive: { activeLanguage },
            children,
            withValues,
            onShown,
            open,
            translatedText,
        } = this.props;

        let tooltipText = translate(translations, activeLanguage, tooltipTK);

        if (withValues) {
            tooltipText = replaceTranslatedStringValues(tooltipText, withValues);
        }

        if (tooltipText || translatedText) {
            return (
                <Tooltip
                    title={tooltipText || translatedText}
                    position={position}
                    trigger={trigger}
                    interactive={interactive}
                    hideOnClick={hideOnClick}
                    arrow={arrow}
                    duration={duration}
                    theme={theme}
                    onShown={onShown}
                    open={open}
                >
                    {children}
                </Tooltip>
            );
        }

        return <span>{children}</span>;
    }
}

ToolTip.propTypes = {
    theme: PropTypes.string,
    translations: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))])
        .isRequired,
    tooltipTK: PropTypes.string,
    storeActive: PropTypes.shape({
        activeLanguage: PropTypes.string.isRequired,
    }).isRequired,
    position: PropTypes.string,
    trigger: PropTypes.string,
    interactive: PropTypes.bool,
    hideOnClick: PropTypes.bool,
    arrow: PropTypes.string,
    duration: PropTypes.string,
    children: PropTypes.node,
    withValues: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};

ToolTip.defaultProps = {
    theme: 'grover',
    tooltipTK: '',
    position: 'top',
    trigger: 'mouseenter',
    interactive: true,
    hideOnClick: false,
    arrow: 'true',
    duration: '250',
    children: null,
    withValues: undefined,
    open: undefined,
};

export default enhance(ToolTip);
